import ufeApi from 'services/api/ufeApi';
import Empty from 'constants/empty';

const path = '/gway/v1/p13n/content/replen';

function normalizeReplenRow(row) {
    if (!row) {
        return null;
    }

    const p13n = row.p13n;

    if (!p13n) {
        return null;
    }

    return {
        context: p13n.context,
        servedSkuNumber: p13n.servedSkuNumber || '',
        productId: p13n.productId || '',
        replenCategory: p13n.replen_category || '',
        skuImageUrl: p13n.skuImageUrl || '',
        caching: p13n.caching,
        isControl: p13n.isControl,
        isDefault: p13n.isDefault,
        isAbTest: p13n.isAbTest,
        isReplenEnabled: p13n.isReplenEnabled,
        abTestId: p13n.abTestId || ''
    };
}

function getP13nReplenData({
    channel, country, language, atgId, contextId
}) {
    const apikey = Sephora.configurationSettings.sdnUfeAPIUserKey;

    const queryParams = `/${contextId}?atg_id=${atgId}&channel=${channel}&locale=${language}-${country}`;

    const url = `${path}${queryParams}`;

    return ufeApi
        .makeRequest(url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'x-api-key': apikey
            }
        })
        .then(({ data = Empty.Array, errorCode }) => {
            if (errorCode) {
                return Promise.reject(data);
            }

            const firstRow = Array.isArray(data) ? data[0] : data;

            return normalizeReplenRow(firstRow);
        });
}

export default getP13nReplenData;
